"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _CornerstoneRow = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneRow"));

var _CornerstoneButton = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneButton"));

var _CornerstoneCol = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneCol"));

var _CornerstoneForm = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneForm"));

var _Message = _interopRequireDefault(require("cornerstone_ui_core/lib/components/Message"));

var _Loader = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneLoader/Loader"));

var _CornerstoneDropdownTable = _interopRequireWildcard(require("cornerstone_ui_core/lib/components/CornerstoneDropdownTable"));

require("./setlocation.scss");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var radioStyle = {
  display: "block",
  height: "30px",
  lineHeight: "30px"
};

var SetLocation = /*#__PURE__*/function (_React$Component) {
  _inherits(SetLocation, _React$Component);

  var _super = _createSuper(SetLocation);

  function SetLocation() {
    var _this;

    _classCallCheck(this, SetLocation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.init();
    });

    _defineProperty(_assertThisInitialized(_this), "init", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var d;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.props.getPersonPysicalSiteClaims();

            case 2:
              d = _context.sent;

              if (d && d.physicalSiteClaims && d.physicalSiteClaims.length > 0) {
                d.physicalSiteClaims.map(function (c) {
                  if (c.active === "Y") {
                    _this.props.setClaimLocation(c.siteDescription);
                  }
                });
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleReset", function () {
      _this.props.handleSubmit();
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function () {
      var _this$props = _this.props,
          physicalSiteClaims = _this$props.physicalSiteClaims,
          selectingPersonDetail = _this$props.selectingPersonDetail;

      try {
        _this.props.form.validateFields(function (err, values) {
          if (values && !err) {
            physicalSiteClaims && physicalSiteClaims.map( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(p) {
                var res;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!(values.locationId === p.siteDescription)) {
                          _context2.next = 12;
                          break;
                        }

                        _context2.prev = 1;
                        _context2.next = 4;
                        return selectingPersonDetail({
                          userNumId: p.userNumId,
                          primary: p.primary
                        });

                      case 4:
                        res = _context2.sent;

                        if (res && res.locationDetail && res.locationDetail.statusMessage) {
                          _this.props.setClaimLocation(values.locationId);

                          localStorage.setItem("claimLocation", values.locationId);
                          localStorage.setItem("PPHSID", p.phsId);

                          _Message.default.success("Location Saved");

                          _this.props.handleSubmit();
                        }

                        _context2.next = 12;
                        break;

                      case 8:
                        _context2.prev = 8;
                        _context2.t0 = _context2["catch"](1);

                        _this.props.handleSubmit();

                        _Message.default.error(_context2.t0.message, JSON.parse(localStorage.getItem("toasterOptions")));

                      case 12:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, null, [[1, 8]]);
              }));

              return function (_x) {
                return _ref2.apply(this, arguments);
              };
            }());
          }
        });
      } catch (err) {
        _this.props.handleSubmit();

        _Message.default.error(err.message, JSON.parse(localStorage.getItem("toasterOptions")));
      }
    });

    return _this;
  }

  _createClass(SetLocation, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          loading = _this$props2.loading,
          form = _this$props2.form;
      var getFieldDecorator = form.getFieldDecorator;
      var _this$props3 = this.props,
          rdsLocation = _this$props3.rdsLocation,
          _this$props3$physical = _this$props3.physicalSiteClaims,
          physicalSiteClaims = _this$props3$physical === void 0 ? [] : _this$props3$physical;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "cornerstone-app td-select-type-loc"
      }, loading ? /*#__PURE__*/_react.default.createElement(_Loader.default, null) : null, /*#__PURE__*/_react.default.createElement(_CornerstoneRow.default, null, /*#__PURE__*/_react.default.createElement(_CornerstoneCol.default, {
        className: "input-box"
      }, /*#__PURE__*/_react.default.createElement(_CornerstoneForm.default.Item, {
        label: "Location"
      }, getFieldDecorator("locationId", {
        initialValue: rdsLocation || null
      })( /*#__PURE__*/_react.default.createElement(_CornerstoneDropdownTable.default, _extends({
        style: {
          width: "100%"
        }
      }, {
        defaultValue: rdsLocation,
        filterOption: true,
        showSearch: true,
        fixedHeader: true,
        dataSource: (0, _CornerstoneDropdownTable.addKeyTitle)((physicalSiteClaims || []).map(function (a) {
          return _objectSpread(_objectSpread({}, a), {}, {
            description: a.description || null
          });
        }), "siteDescription", "siteDescription", true),
        columns: [{
          title: "Location",
          dataIndex: "siteDescription",
          key: "siteDescription"
        }]
      })))))), /*#__PURE__*/_react.default.createElement(_CornerstoneRow.default, {
        className: "fixedFooter td_select_modal_footer"
      }, /*#__PURE__*/_react.default.createElement(_CornerstoneCol.default, {
        className: "col-float",
        span: 30
      }, /*#__PURE__*/_react.default.createElement(_CornerstoneButton.default, {
        className: "ripple button-margin-tdselect",
        onClick: this.handleReset
      }, "Cancel"), /*#__PURE__*/_react.default.createElement(_CornerstoneButton.default, {
        className: "ripple button-margin-tdselect",
        htmlType: "submit",
        onClick: this.handleSubmit,
        type: "primary"
      }, "OK"))));
    }
  }]);

  return SetLocation;
}(_react.default.Component);

var _default = _CornerstoneForm.default.create({
  name: "td-select-type"
})(SetLocation);

exports.default = _default;